import { createContext } from "react";

export const ConfigInvContext = createContext({
  configInv: { minStok: 50 },
  setConfigInv: () => {},
});
